import SkeletonList from "./SkeletonList";

type CardSkeletonProps = {
  maxWidth?: number;
  width?: number;
  className?: string;
  rows?: number;
};

export default function CardSkeleton({ maxWidth = 100, width, className, rows = 3 }: CardSkeletonProps) {
  const style = {
    width: width ? `${width}%` : `${Math.random() * (maxWidth - 25) + 25}%`
  };

  return (
    <div
      className={`border border-sys-brand-outline-variant rounded-lg p-6 ${className}`}
      data-testid="member-insights-skeleton"
      style={style}
    >
      <SkeletonList rows={rows} />
    </div>
  );
}
